<aux-protocol-section
  *ngIf="(isProtocolVersionLoading$ | async) === false"
  className="my-4"
  [versionOptions]="protocolVersionOptions"
  [patientOptions]="patientOptions"
  [isVersionControlEditable]="true"
  [isAmendmentDisabled]="(editModeGrid$ | async) === true"
  (valuesChange)="onChangePatientGroup($event)"
  (formReady)="onProtocolFormReady($event)"
  (amendmentClick)="createProtocol($event)"
  (editProtocolVersion)="editProtocolVersion($event)"
  (deleteProtocolVersion)="deleteProtocolVersion($event)"
  [template]="actionButtons"
>
</aux-protocol-section>

<ng-template #actionButtons>
  <div class="flex justify-end space-x-2" *ngIf="(isProtocolVersionLoading$ | async) === false">
    <ng-container *auxAuthorize="{ sysAdminsOnly: true }">
      <aux-button
        *ngIf="!protocolVersionOptions.length"
        icon="circle-plus"
        label="Create Protocol"
        variant="secondary"
        [spinnerSize]="7"
        [onClick]="createProtocol"
      >
      </aux-button>
    </ng-container>

    <aux-button
      *ngIf="(editModeGrid$ | async) === false && protocolVersionOptions.length"
      variant="secondary"
      label="Edit"
      icon="pencil"
      [onClick]="editGrid"
    ></aux-button>

    <aux-button
      *ngIf="(editModeGrid$ | async) === true"
      variant="secondary"
      label="Cancel"
      icon="x"
      [onClick]="cancelEditMode"
    ></aux-button>

    <aux-button
      *ngIf="(editModeGrid$ | async) === true"
      variant="success"
      label="Save"
      icon="check"
      class="ml-1"
      [disabled]="!hasChanges"
      [onClick]="onSaveAll"
    ></aux-button>
  </div>
</ng-template>

<ng-container *ngIf="$any(loading$ | async)">
  <div class="border-8 h-32 m-auto mt-40 spinner w-32"></div>
</ng-container>

<div *ngIf="!$any(loading$ | async)">
  <ag-grid-angular
    id="patientBudgetEntryGrid"
    domLayout="autoHeight"
    class="ag-theme-aux tabular-nums"
    [gridOptions]="$any(gridOptions$ | async)"
    [rowData]="$any(gridData$ | async)"
    [enableFillHandle]="(editModeGrid$ | async) === true"
    [rowDragManaged]="true"
    [animateRows]="true"
    (gridReady)="onGridReady($event)"
    (cellValueChanged)="cellValueChanged($event)"
    (rowDragEnd)="onRowDragEnd($event)"
    (viewportChanged)="onWindowScroll()"
    (gridSizeChanged)="gridSizeChanged()"
  ></ag-grid-angular>

  <div class="mt-4" *ngIf="(editModeGrid$ | async) === true">
    <aux-button
      variant="primary"
      label="Add Entry"
      [onClick]="onAddPatientProtocol.bind(this)"
    ></aux-button>
  </div>
</div>
